/**
 * The kind of party in a case subject collection (e.g. tenants, defendants).
 * Generalizes the tenant-only collection; absence is treated as INDIVIDUAL.
 */
export enum SubjectType {
  INDIVIDUAL = 'INDIVIDUAL',
  ORGANIZATION = 'ORGANIZATION'
}
